import React from 'react';
import { withRouter } from 'us.common/wIthRouter';
import { MainSearch } from 'us.common/components';


const Cnt_MainSearch: React.FC = (props) => {
	return <MainSearch {...props} />;
};

export default withRouter(Cnt_MainSearch);
